
import { Table, TableBody, ButtonGroup,Badge, Modal, TableCell, TableContainer, TableHead, TableRow,  AppBar, Box, Toolbar, TextField, useTheme, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Typography, Divider,CssBaseline } from "@mui/material";
import  { useState, useEffect } from "react";

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import HelpIcon from '@mui/icons-material/HelpOutline';
import ViewListIcon from '@mui/icons-material/ViewList';
import CloseIcon from '@mui/icons-material/Close';
import Close from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';


// import '../../../components/boxstyles.css';

import Searchicon from '@mui/icons-material/Search';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

import AddNewRequestIndent from "./AddRequestIndent";
import useRequestIndentList from "../../../hooks/useRequestIndentList";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import RequestIndent from "./Request-Indent";
import { tokens } from "../../../theme/theme";

const ApproveRequestIndent = ({ handleBackWinderMachineEntry, formMode }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Approved Request Indent');
    
    const [selectedStatus, setSelectedStatus] = useState('All');
    const openFirst = Boolean(anchorElFirst);
    const [newRequestIndent, setNewRequestIndent] = useState(false);
    const [viewRequestIndent, setViewRequestIndent] = useState(false);
    const [requestIndentHome, setRequestIndentHome] = useState(true);
    const [selectedMode, setSelectedMode] = useState(1);

    const [selectedRows, setSelectedRows] = useState([]);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [showNewToolbar, setShowNewToolbar] = useState(false);

    const [notification, setNotification] = useState(0);
    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);

    const [anchorElMenu, setAnchorElMenu] = useState(null);
    

    //const { requestIndentList, setRequestIndentList, selectRequestIndent, selectRequestIndentID, loadRequestIndentByID, } = useRequestIndentList('approved indent');
    //const { requestIndentList, setRequestIndentList, selectRequestIndent, selectRequestIndentID, loadRequestIndentByID, } = useRequestIndentList('request indent');
    const requestIndentDet=useRequestIndentList('approved indent');
    const notifyCreatedIndent = useRequestIndentList('notify request indent');



    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Approved Request Indent') {
            setSelectedStatus('All');
        }
        // else if (option === 'Approved Request Indent') {
        //     setSelectedStatus('Approved');
        // }
        // else if (option === 'Un Approved Request Indent') {
        //     setSelectedStatus('Un Approved');
        // }


        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };

    const [editRequestIndentID, setEditRequestIndentID] = useState(0);

    const handleShowNewVendor = () => {
        setEditRequestIndentID(0);
        setRequestIndentHome(false);
        setNewRequestIndent(true);
        setViewRequestIndent(false);
    }

    const handleShowRequestIndentList = () => {
        setEditRequestIndentID(0);
        setRequestIndentHome(false);
        setNewRequestIndent(false);
        setViewRequestIndent(true);
    }
    const handleCallEdit = (value, poID, poNumber) => {
        setEditRequestIndentID(value);

        setRequestIndentHome(false);
        setNewRequestIndent(true);
    };

    const handlecallback = () => {
        setRequestIndentHome(true);
        setNewRequestIndent(false);
        setViewRequestIndent(false);
        requestIndentDet.loadRequestIndentByID();

    }

    useEffect(() => {
        const list = notifyCreatedIndent.requestIndentList;
        if (Array.isArray(list) && list.length) {
            setNotification(list.length);
        }
    }, [notifyCreatedIndent.requestIndentList]);

    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState({
        material_code: '',
        material_name: '',
        status: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };





    const filteredData = requestIndentDet.requestIndentList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const handleNewToolbarClose = () => {
        setShowNewToolbar(false); // Hide new toolbar
        setShowFirstToolbar(true);
    };

    const handleBulkUpdate = () => {
        console.log('Bulk Update');
    };

    const handleMarkAsIssued = () => {
        console.log('Mark as Issued');
    };

    const handleBulkCancelItems = () => {
        console.log('Bulk Cancel Items');
    };

    const handleBulkReopenCancelledItems = () => {
        console.log('Bulk Reopen Cancelled Items');
    };

    const handleConvertToBill = () => {
        console.log('Convert to Bill');
    };

  

    return (
        <Box >
            <CssBaseline />
            {requestIndentHome && (

                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        {showFirstToolbar && (
                            <>
                                <Button
                                    color="secondary"
                                    onClick={handleMenuClickFirst}
                                    endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                    sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                                >
                                    {selectedOptionFirst}
                                </Button>
                                <Menu
                                    anchorEl={anchorElFirst}
                                    open={openFirst}
                                    onClose={handleMenuCloseFirst}

                                >
                                    <MenuItem onClick={() => handleMenuItemClickFirst('All Request Indent')}>All </MenuItem>


                                </Menu>

                                {/* Adding margin-left: auto to push the button to the right  startIcon={<AddIcon sx={{ fontSize: "18px" }} />}*/}
                                {formMode === 0 ? (
                                    <>
                                        <Button size="small" variant="contained" onClick={handleShowRequestIndentList} color="secondary"
                                            startIcon={
                                                <Badge
                                                    badgeContent={notification}
                                                    color="error"
                                                    overlap="circular"
                                                    sx={{
                                                        "& .MuiBadge-badge": {
                                                            fontSize: "10px",
                                                            height: "16px",
                                                            minWidth: "16px",
                                                            padding: "0 4px",
                                                        },
                                                    }}
                                                >
                                                    <ViewListIcon sx={{ fontSize: "18px" }} />
                                                </Badge>
                                            } sx={{ marginLeft: 'auto', textTransform: 'none' }}>View Request Indent</Button>
                                        {/* <Button size="small" disabled variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: "5px", textTransform: 'none' }}>New</Button> */}
                                    </>
                                ) : (
                                    
                                     < Button size="small" disabled variant="contained" onClick={handleShowNewVendor} color="secondary" sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>
                                )}


                                {/* Second Menu */}
                                <IconButton
                                    size="small"
                                    // edge="start"
                                    color="secondary"
                                    aria-label="menu"

                                    sx={{ fontSize: "18px", ml: 2 }}
                                    onClick={handleMenuClickSecond}
                                >
                                    <MoreVertIcon sx={{ fontSize: "18px" }} />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorElSecond}
                                    open={openSecond}
                                    onClose={handleMenuCloseSecond}
                                >
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Import Request Indent')}>
                                        <ListItemIcon>
                                            <ImportExportIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Import Request Indent" />
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Export Request Indent')}>
                                        <ListItemIcon>
                                            <FileDownloadIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Export Request Indent" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                        <ListItemIcon>
                                            <ListAltIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Preference " />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                        <ListItemIcon>
                                            <RefreshIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Refresh List" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                        <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                            Reset Columns Width
                                        </Button>
                                    </MenuItem>
                                </Menu>

                                <IconButton
                                    size="small"
                                    // edge="start"
                                    // color="inherit"
                                    aria-label="menu"
                                    sx={{ fontSize: "18px", mr: 1, ml: 1 }}
                                    onClick={handleMenuClickSecond}
                                >
                                    <HelpIcon sx={{ fontSize: "18px" }} />
                                </IconButton>
                                <div>
                                    <IconButton onClick={handleBackWinderMachineEntry} >
                                        <Close fontSize="inherit" style={{ color: "#2196F3", fontSize: "18px" }} />
                                    </IconButton>
                                </div>
                            </>
                        )}

                        {showNewToolbar && (
                            <>
                                <Button
                                    variant="outlined"
                                    color="secondary"

                                    onClick={handleMenuClickFirst}
                                    endIcon={<ArrowDropDownIcon sx={{ color: "teal" }} />}
                                    sx={{ textTransform: 'none', fontSize: "10px", fontWeight: "bold" }}
                                >
                                    {/* {selectedOptionFirst} */}
                                    <Typography variant="h6">
                                        Bulk Updates
                                    </Typography>
                                </Button>
                                <Menu
                                    anchorEl={anchorElFirst}
                                    open={openFirst}
                                    onClose={handleMenuCloseFirst}

                                >
                                    <MenuItem onClick={() => handleBulkUpdate()}>Bulk Update </MenuItem>
                                    <MenuItem onClick={() => handleMarkAsIssued()}>Mark as Issued</MenuItem>
                                    <MenuItem onClick={() => handleBulkCancelItems()}>Bulk Cancel Items</MenuItem>
                                    <MenuItem onClick={() => handleBulkReopenCancelledItems()}>Bulk reopen Canceled items</MenuItem>
                                    <MenuItem onClick={() => handleConvertToBill()}>Convert to Bill</MenuItem>
                                    {/* <MenuItem onClick={() => handleMenuItemClickFirst('Billed Purchase Orders')}>Billed</MenuItem> */}
                                </Menu>



                                <ButtonGroup color="secondary" variant="outlined" style={{ marginLeft: 10 }}>
                                    <Button aria-label="email" sx={{ padding: "6px", minWidth: 40 }}>
                                        <EmailIcon style={{ fontSize: "20px", color: "#5c6bc0" }} />
                                    </Button>
                                    <Button aria-label="pdf" sx={{ padding: 0, minWidth: 40 }}>
                                        <PictureAsPdfIcon style={{ fontSize: "20px", color: "#d32f2f" }} />
                                    </Button>
                                    <Button aria-label="print" sx={{ padding: 0, minWidth: 40 }}>
                                        <PrintIcon style={{ fontSize: "20px", color: "#64b5f6" }} />
                                    </Button>
                                </ButtonGroup>
                                <ButtonGroup color="secondary" variant="outlined" style={{ marginLeft: 10 }}>
                                    <Button aria-label="delete" sx={{ padding: "6px", minWidth: 40 }}>
                                        <DeleteIcon style={{ fontSize: "20px", color: "#ff7043" }} />
                                    </Button>
                                </ButtonGroup>
                                <IconButton size="small" aria-label="close" sx={{ marginLeft: 2 }} >
                                    <FiberManualRecordIcon sx={{ fontSize: "12px", color: "green" }} />
                                </IconButton>
                                <Typography variant="h6" >
                                    {`${selectedRows.length} Purchase Order${selectedRows.length > 1 ? 's' : ''} selected`}
                                </Typography>


                                <IconButton size="small" aria-label="close" sx={{ marginLeft: 'auto', mr: 1 }} onClick={handleNewToolbarClose}>
                                    <CloseIcon />
                                </IconButton>
                            </>
                        )}

                    </Toolbar>
                </AppBar>



            )
            }

            {
                requestIndentHome && (


                    <CustomTableContainer colors={colors}>
                        <TableContainer >
                            <Table size="small">
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow>

                                        <TableCell>REQUEST DATE</TableCell>
                                        <TableCell>REQUEST INDENT #</TableCell>
                                        <TableCell>DEPARTMENT</TableCell>
                                        <TableCell>REQUESTER</TableCell>
                                        <TableCell>APPROVED DATE</TableCell>
                                        <TableCell>APPROVED BY</TableCell>
                                        <TableCell>STATUS</TableCell>


                                        <TableCell>
                                            <IconButton onClick={handleOpen}>
                                                <Searchicon style={{ fontSize: "16px" }} />
                                            </IconButton>
                                            <Modal
                                                open={open}
                                                onClose={handleClose}
                                                aria-labelledby="modal-modal-title"
                                                aria-describedby="modal-modal-description"
                                            >
                                                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>

                                                    <TextField
                                                        label="Request Indent Number"
                                                        name="request_indent_number"
                                                        value={filters.request_indent_number}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                    />
                                                    <TextField
                                                        label="Status"
                                                        name="status"
                                                        value={filters.status}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                    />
                                                    <TextField
                                                        label="Requester Name"
                                                        name="employee_name"
                                                        value={filters.employee_name}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                    />
                                                    <TextField
                                                        label="Department"
                                                        name="department"
                                                        value={filters.department}
                                                        onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                    />

                                                    <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                        Apply Filter
                                                    </Button>
                                                </Box>
                                            </Modal>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredData.map((row) => (
                                        <TableRow key={row.id_request}>
                                            <TableCell>{row.request_date}</TableCell>

                                            <TableCell>
                                                <span
                                                    style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                    onClick={() => handleCallEdit(row.id_request)}
                                                >
                                                    {row.request_indent_number}
                                                </span>
                                            </TableCell>
                                            <TableCell>{row.department}</TableCell>
                                            <TableCell>{row.employee_name}</TableCell>
                                            <TableCell>{row.approved_date || ''}</TableCell>
                                            <TableCell>{row.approved_name || 'Not Approved'}</TableCell>
                                            <TableCell>{row.status}</TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CustomTableContainer>


                )
            }


            {/* New Vendor */}
            {
                newRequestIndent && (
                    <>
                        <AddNewRequestIndent handlecallback={handlecallback} editRequestIndentID={editRequestIndentID} selectedMode={selectedMode} setSelectedMode={setSelectedMode} formMode={formMode} />
                    </>

                )
            }

            {/* view Avaliable Request */}
            {
                viewRequestIndent && (
                    <>
                        <RequestIndent handleBackWinderMachineEntry={handlecallback} formMode={0} tableMode={'created indent'} />
                    </>
                )
            }


        </Box>
    );
}

export default ApproveRequestIndent;





